import { render, staticRenderFns } from "./role.vue?vue&type=template&id=38e7f968&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e7f968",
  null
  
)

export default component.exports